var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosePanel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.56522 0C0.703125 0 0 0.703125 0 1.56522V18.2609C0 19.123 0.703125 19.8261 1.56522 19.8261H22.4348C23.2969 19.8261 24 19.123 24 18.2609V1.56522C24 0.703125 23.2969 0 22.4348 0H1.56522ZM1.56522 1.04348H14.087V18.7826H1.56522C1.27785 18.7826 1.04348 18.5482 1.04348 18.2609V1.56522C1.04348 1.27785 1.27785 1.04348 1.56522 1.04348ZM8.86753 6.7765C8.65557 6.7765 8.46399 6.90489 8.38247 7.10054C8.30095 7.2962 8.34783 7.52242 8.49864 7.6712L10.1984 9.3913H3.65217C3.46467 9.38927 3.2894 9.48709 3.19361 9.65014C3.09986 9.81318 3.09986 10.0129 3.19361 10.176C3.2894 10.339 3.46467 10.4368 3.65217 10.4348H10.1984L8.49864 12.1549C8.36413 12.2874 8.3091 12.481 8.35802 12.6644C8.40693 12.8458 8.54959 12.9885 8.73302 13.0353C8.91644 13.0822 9.11005 13.0251 9.24049 12.8886L12.1814 9.91304L9.24049 6.9375C9.14266 6.8356 9.00815 6.77853 8.86753 6.7765Z",
    fill: "#0D1D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePanel);
export default __webpack_public_path__ + "static/media/close_panel.4c8c0c7219aa23fe2278a89fc5d63374.svg";
export { ForwardRef as ReactComponent };